var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var PillarIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 34,
    glyphHeight: 64
  }), React.createElement("path", {
    d: "M33.6957 0.695679H0.304352V9.0435H33.6957V0.695679Z"
  }), React.createElement("path", {
    d: "M33.6957 54.9565H0.304352V63.3044H33.6957V54.9565Z"
  }), React.createElement("path", {
    d: "M21.1739 13.2174H12.8261V50.7826H21.1739V13.2174Z"
  }), React.createElement("path", {
    d: "M29.5218 13.2174H25.3478V50.7826H29.5218V13.2174Z"
  }), React.createElement("path", {
    d: "M8.65218 13.2174H4.47827V50.7826H8.65218V13.2174Z"
  }));
};
export var PillarIconGlyph = function (props) {
  return React.createElement(PillarIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};